
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[p]",
      function () {
        return require("private-next-pages/p/[p].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[p]"])
      });
    }
  